import React, {useState} from "react";
import {
    Button, CircularProgress,
    FormControl,
    IconButton,
    Input,
    InputAdornment,
    InputLabel,
    TextField,
    Typography,
    withStyles
} from "@material-ui/core";
import {Formik} from "formik";
import * as Yup from "yup";
import clsx from "clsx";
import {Visibility, VisibilityOff} from "@material-ui/icons";
import {connect} from "react-redux";
import * as actions from "../../sc-core/Auth/store/authActions";

const styles = theme => ({
    formControl: {
        width: "100%",
        marginBottom: '5px',
    },
    buttonDiv: {
        width: 'auto',
        marginTop: theme.spacing(2),
        textAlign: 'center',
    },
    submit: {
        width: '13rem',
        marginLeft: theme.spacing(2),
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    cancel: {
        width: "13rem",
    },
});

const SessionExpiredForm = (props) => {
    const { classes, translations, token, activeCustomerID, onExtendSession, onLogout } = props;
    const [passwordVisibility, setPasswordVisibility] = useState(false);

    const handleClickShowPassword = () => {
        setPasswordVisibility((previousValue) => !previousValue);
    };
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleSubmit = async data => {
        const loginData = {
            ...data,
            Token: token,
            ActiveCustomerID: activeCustomerID
        };
        await onExtendSession(loginData);
    };

    const cancelHandler = () => {
        onLogout(activeCustomerID);
    };

    const initialValues = {
        Username: null,
        Password: null,
    };

    const formSettings = {
        Validation: {
            Username: Yup.string().required("Required"),
            Password: Yup.string().required("Required"),
        },
        ButtonSubmit: {
            Title: translations["extend_session"] || "Extend session",
            Color: "primary"
        },
        ButtonCancel: {
            Title: translations["logout"] || "LOGOUT",
            handleCancel: cancelHandler
        }
    };

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(true);
                await handleSubmit(values);
                setSubmitting(false);
            }}
            validationSchema={Yup.object().shape(formSettings.Validation)}
        >
            {formikProps => {
                const { values, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit, errors, touched } = formikProps;

                return (
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                        <TextField
                            label={translations['username'] || 'Username'}
                            placeholder={translations['username'] || 'Username'}
                            name="Username"
                            fullWidth={true}
                            value={values.Username || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            margin="dense"
                            error={!!(errors.Username && touched.Username)}
                        />
                        <FormControl className={clsx(classes.margin, classes.formControl)}>
                            <InputLabel htmlFor="in-category-1">{translations['password'] || 'Password'}</InputLabel>
                            <Input
                                id="in-category-1"
                                type={passwordVisibility ? 'text' : 'password'}
                                name="Password"
                                value={values.Password || ""}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Password && touched.Password)}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                        >
                                            {passwordVisibility ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>


                        <div className={classes.buttonDiv}>
                            {formSettings.ButtonCancel ? (
                                <Button
                                    className={classes.cancel}
                                    variant="contained"
                                    color={formSettings.ButtonCancel.Color}
                                    onClick={formSettings.ButtonCancel.handleCancel}
                                >
                                    {formSettings.ButtonCancel.Title}
                                </Button>
                            ) : null}
                            {formSettings.ButtonSubmit ? (
                                <Button
                                    className={classes.submit}
                                    variant="contained"
                                    color={formSettings.ButtonSubmit.Color}
                                    type="submit"
                                    fullWidth={true}
                                    disabled={isSubmitting || !(isValid && dirty)}
                                >
                                    {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                </Button>
                            ) : null}
                        </div>
                    </form>
                );
            }}
        </Formik>
    );
}

const mapStateToProps = state => {
    return {
        token: state?.core?.login?.token,
        activeCustomerID: state?.core?.login?.activeCustomer?.CustomerID,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onExtendSession: loginData => dispatch(actions.extendSession(loginData)),
        onLogout: (activeCustomerID) => dispatch(actions.logout(activeCustomerID)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SessionExpiredForm));